import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
    providedIn: "root",
})
export class RouterService {
    private states: RouteInfo[] = [];

    constructor(private router: Router) {}

    init(path: string): void {
        this.states.push({ path: path, queryParams: {} }); // Initial state
    }

    navigate(path: string, queryParams?: any, replaceUrl?: boolean): void {
        this.states.push({ path, queryParams });
        this.router.navigate([path], { queryParams, replaceUrl });
    }

    navigateBack(): void {
        if (this.states.length > 1) {
            this.states.pop();
        }

        const state: RouteInfo = this.states[this.states.length - 1];
        this.router.navigate([state.path], { queryParams: state.queryParams });
    }
}

type RouteInfo = {
    path: string;
    queryParams?: any;
};
